import React from "react";
import { Container, Typography, Box, Link, Divider } from "@mui/material";

const TermsAndConditions = () => {
  return (
    <Container maxWidth="md" sx={{ marginTop: 4 }}>
      <Typography variant="h4" align="center" gutterBottom>
        Allmänna köpvillkor
      </Typography>

      <Box mb={4}>
        <Typography variant="h6" gutterBottom>
          Introduktion
        </Typography>
        <Typography variant="body1" paragraph>
          Dessa Villkor ("Villkoren") reglerar köp av produkter från{" "}
          <Link href="https://dolcehem.se">https://dolcehem.se</Link>{" "}
          (hädanefter benämnda "vi," "oss," "vår"). Genom att göra ett köp
          godkänner du ("kund," "du," "din") att vara bunden av dessa Villkor.
          Läs dem noggrant.
        </Typography>
        <Typography variant="body1" paragraph>
          <strong>Företagsuppgifter:</strong> THAS Multitech AB ("Dolcehem"), Org.nr: 559394-1957, Stockholm, Sweden.<br />
          <strong>E-post:</strong> info@dolcehem.se
        </Typography>
      </Box>

      <Box mb={4}>
        <Typography variant="h6" gutterBottom>
          1. Definitioner
        </Typography>
        <Typography variant="body1" paragraph>
          • <strong>Produkter:</strong> Varor och tjänster som erbjuds till
          försäljning på vår webbplats.<br />
          • <strong>Order:</strong> Din begäran att köpa Produkter från vår webbplats.<br />
          • <strong>Webbplats:</strong> www.dolcehem.se<br />
          • <strong>Dagar:</strong> Kalenderdagar.
        </Typography>
      </Box>

      <Box mb={4}>
        <Typography variant="h6" gutterBottom>
          2. Beställningsprocess
        </Typography>
        <Typography variant="body1" paragraph>
          • <strong>Beställning:</strong> Beställningar kan göras via vår
          webbplats genom att följa instruktionerna på kassasidan.<br />
          • <strong>Orderbekräftelse:</strong> När en beställning görs får du en
          e-postbekräftelse. Denna bekräftelse innebär inte att vi accepterar
          din order; det är endast en bekräftelse på att vi mottagit din
          beställning.<br />
          • <strong>Ordergodkännande:</strong> Vi accepterar din order när vi skickar
          produkterna till dig. Vi kan avvisa din order om vi inte kan godkänna
          betalningen, om produkterna är slutsålda eller av annan anledning enligt
          vårt eget omdöme.<br />
          • <strong>Produktens tillgänglighet:</strong> Kunden bekräftar och accepterar
          att produktens tillgänglighet beror på lagernivåerna vid orderbehandling.
        </Typography>
      </Box>

      <Box mb={4}>
        <Typography variant="h6" gutterBottom>
          3. Priser och betalning
        </Typography>
        <Typography variant="body1" paragraph>
          • <strong>Prissättning:</strong> Alla priser anges i svensk valuta
          (SEK) och inkluderar tillämpliga skatter, om inget annat anges. Priser
          kan ändras utan föregående meddelande, men ändringar påverkar inte
          redan bekräftade ordrar.<br />
          • <strong>Betalningsmetod:</strong> För närvarande erbjuder vi endast
          betalning via Klarna. Genom att välja Klarna i kassan kan du använda deras
          betalningsalternativ, inklusive direktbetalning, faktura och delbetalning,
          i enlighet med Klarnas villkor.<br />
          • <strong>Betalningsvillkor:</strong> Betalning ska göras i sin helhet
          vid beställningstillfället.
        </Typography>
      </Box>

      <Box mb={4}>
        <Typography variant="h6" gutterBottom>
          4. Leverans och risk för förlust
        </Typography>
        <Typography variant="body1" paragraph>
          • <strong>Leveransvillkor:</strong> Vi levererar produkterna till den
          adress du anger under beställningsprocessen. Leveranstider är
          uppskattningar och inte garanterade.<br />
          • <strong>Fraktkostnader:</strong> Fraktkostnader läggs till
          produktpriset och visas i kassan.<br />
          • <strong>Risk för förlust:</strong> Risken för förlust eller skada på
          produkterna övergår till dig vid leverans.
        </Typography>
      </Box>

      <Box mb={4}>
        <Typography variant="h6" gutterBottom>
          5. Inspektion och godkännande
        </Typography>
        <Typography variant="body1" paragraph>
          • <strong>Inspektion:</strong> Du bör inspektera produkterna vid
          leverans och meddela oss om eventuella defekter eller problem så snart
          som möjligt.<br />
          • <strong>Reklamationsrätt:</strong> Du har rätt att reklamera fel i upp
          till 3 år enligt konsumentköplagen. Fel som reklameras inom två månader
          från att du märkt dem anses alltid vara i rätt tid.
        </Typography>
      </Box>

      <Box mb={4}>
        <Typography variant="h6" gutterBottom>
          6. Ångerrätt, returer och återbetalningar
        </Typography>
        <Typography variant="body1" paragraph>
          • <strong>Ångerrätt:</strong> Du har rätt att ångra ditt köp inom 14
          dagar från den dag du tagit emot varan. Efter att du meddelat oss har du
          ytterligare 14 dagar på dig att returnera varan.<br />
          • <strong>Returvillkor:</strong> Produkterna ska vara i väsentligen
          oförändrat skick och i originalförpackning.<br />
          • <strong>Ej returnerbara varor:</strong> Vissa varor är undantagna från
          ångerrätten, t.ex. specialtillverkade produkter och förseglade
          hygienprodukter med bruten försegling. Detta anges i respektive
          produktbeskrivning.<br />
          • <strong>Återbetalning:</strong> Vid godkänd retur återbetalar vi varans
          pris och standardfrakten (ej tillval som expressfrakt) inom 14 dagar från
          att vi mottagit ditt ångermeddelande. Vi kan avvakta med återbetalning
          tills vi fått tillbaka varan eller bevis på att den har skickats.<br />
          • <strong>Returfrakt:</strong> Du betalar returfrakten om inte varan är
          felaktig eller skadad vid leverans.
        </Typography>
      </Box>

      <Box mb={4}>
        <Typography variant="h6" gutterBottom>
          7. Garantier och ansvar
        </Typography>
        <Typography variant="body1" paragraph>
          • <strong>Produktgaranti:</strong> Vi garanterar att produkterna är av
          tillfredsställande kvalitet och lämpade för avsett ändamål. Garantin
          täcker inte fel orsakade av felaktig användning eller normalt slitage.<br />
          • <strong>Ansvarsbegränsning:</strong> I den utsträckning som lagen
          tillåter begränsas vårt ansvar till inköpspriset för produkterna.
        </Typography>
      </Box>

      <Box mb={4}>
        <Typography variant="h6" gutterBottom>
          8. Sekretess
        </Typography>
        <Typography variant="body1" paragraph>
          Vi behandlar personuppgifter i enlighet med vår Integritetspolicy. När du
          väljer Klarna som betalningsmetod är Klarna självständigt personuppgiftsansvarig
          för sin behandling av dina uppgifter – se Klarnas integritetspolicy.
        </Typography>
      </Box>

      <Box mb={4}>
        <Typography variant="h6" gutterBottom>
          9. Efterlevnad av lagar
        </Typography>
        <Typography variant="body1" paragraph>
          Du samtycker till att följa alla tillämpliga lagar och förordningar
          avseende ditt köp och användning av produkterna.
        </Typography>
      </Box>

      <Box mb={4}>
        <Typography variant="h6" gutterBottom>
          10. Force majeure
        </Typography>
        <Typography variant="body1" paragraph>
          Vi är inte ansvariga för förseningar eller oförmåga att uppfylla våra
          åtaganden om detta orsakas av händelser utanför vår rimliga kontroll
          (t.ex. naturkatastrofer, krig, strejker).
        </Typography>
      </Box>

      <Box mb={4}>
        <Typography variant="h6" gutterBottom>
          11. Uppsägning
        </Typography>
        <Typography variant="body1" paragraph>
          Vi kan säga upp avtalet med omedelbar verkan om du bryter mot dessa
          villkor. Vid uppsägning måste du upphöra med att använda produkterna
          och vi är inte ansvariga för kompensation utöver vad som anges i dessa
          villkor.
        </Typography>
      </Box>

      <Box mb={4}>
        <Typography variant="h6" gutterBottom>
          12. Tillämplig lag och tvistlösning
        </Typography>
        <Typography variant="body1" paragraph>
          Dessa villkor regleras av svensk lag. Tvist kan prövas av Allmänna
          reklamationsnämnden (ARN) eller allmän domstol. Om du bor i ett annat
          EU-land kan du använda EU:s ODR-plattform.
        </Typography>
      </Box>

      <Divider />
    </Container>
  );
};

export default TermsAndConditions;
